<template>
<div class="chapter">
<div class="inner_page">
<h1>The Sweeper Of Loray</h1>
<h2 class="sigil_not_in_toc">And Three More Stories</h2>
<h2 class="sigil_not_in_toc">Robert Sheckley</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?695b70b1